// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"650":"3f25cc6a","794":"5a3922d9"}[chunkId] + ".chunk.css";
};